import Graphics from './Graphics';

export default Graphics;




// WEBPACK FOOTER //
// ./src/components/Graphics/index.ts